var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollToTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71854 0.576622C3.53861 0.38136 3.2469 0.38136 3.06697 0.576622L0.134943 3.7586C-0.0449811 3.95387 -0.0449811 4.27045 0.134943 4.46571C0.314867 4.66097 0.606581 4.66097 0.786505 4.46571L2.93203 2.13728V6.93018C2.93203 8.86317 4.37595 10.4302 6.1571 10.4302H8V9.43018H6.1571C4.88485 9.43018 3.85348 8.31089 3.85348 6.93018V2.13728L5.99901 4.46571C6.17893 4.66097 6.47065 4.66097 6.65057 4.46571C6.83049 4.27045 6.83049 3.95387 6.65057 3.7586L3.71854 0.576622Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollToTop);
export default __webpack_public_path__ + "static/media/scrollToTop.8d4916a3b21b48dd05e78f5b16859b20.svg";
export { ForwardRef as ReactComponent };